// extracted by mini-css-extract-plugin
module.exports = {"fixedNavbar":"style-module__fixedNavbar___2LI4L","logo":"style-module__logo___292AY"};